var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4861 5.49154C4.34804 5.35348 4.28063 5.19013 4.28389 5.0015C4.28717 4.81154 4.36026 4.64511 4.50317 4.5022C4.64608 4.35929 4.81218 4.28653 5.00146 4.28392C5.19074 4.28132 5.35409 4.34872 5.49151 4.48614L20.0756 19.0702C20.2136 19.2083 20.2807 19.3719 20.2768 19.5613C20.2729 19.7506 20.2004 19.9163 20.0595 20.0585C19.9186 20.2008 19.7525 20.2735 19.5612 20.2768C19.3699 20.2801 19.2063 20.213 19.0702 20.0756L4.4861 5.49154Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3562 5.49154C20.4942 5.35348 20.5617 5.19013 20.5584 5.0015C20.5551 4.81154 20.482 4.64511 20.3391 4.5022C20.1962 4.35929 20.0301 4.28653 19.8408 4.28392C19.6515 4.28132 19.4882 4.34872 19.3508 4.48614L4.76671 19.0702C4.62865 19.2083 4.56158 19.3719 4.56551 19.5613C4.56943 19.7506 4.64186 19.9163 4.78278 20.0585C4.9237 20.2008 5.0898 20.2735 5.28107 20.2768C5.47234 20.2801 5.63603 20.213 5.77212 20.0756L20.3562 5.49154Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.952b828d7e6120fa8fadab7d84069754.svg";
export { ForwardRef as ReactComponent };